// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QnoBHa4Q9Hkjs0N_OI_Qf input::-webkit-inner-spin-button,.QnoBHa4Q9Hkjs0N_OI_Qf input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.QnoBHa4Q9Hkjs0N_OI_Qf input[type=number]{-moz-appearance:textfield}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": "QnoBHa4Q9Hkjs0N_OI_Qf"
};
module.exports = ___CSS_LOADER_EXPORT___;
